// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardRelay__KeyFacts__Price = require("./PropertyWizardRelay__KeyFacts__Price.bs.js");
let PropertyWizardRelay__KeyFacts__DraftType = require("./PropertyWizardRelay__KeyFacts__DraftType.bs.js");
let PropertyWizardRelayKeyFacts_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFacts_draft_graphql.bs.js");
let PropertyWizardRelay__KeyFacts__RentalData = require("./PropertyWizardRelay__KeyFacts__RentalData.bs.js");
let PropertyWizardRelay__KeyFacts__PropertyType = require("./PropertyWizardRelay__KeyFacts__PropertyType.bs.js");
let PropertyWizardRelay__KeyFacts__StreetAddress = require("./PropertyWizardRelay__KeyFacts__StreetAddress.bs.js");
let PropertyWizardRelayKeyFacts_formState_graphql = require("../../../__generated__/PropertyWizardRelayKeyFacts_formState_graphql.bs.js");

let convertFragment = PropertyWizardRelayKeyFacts_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFacts_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFacts_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFacts_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFacts_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayKeyFacts_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayKeyFacts_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardRelayKeyFacts_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFacts_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFacts_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFacts_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFacts_formState_graphql.node, convertFragment$1, fRef);
}

let FormStateFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__KeyFacts(props) {
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFacts_draft_graphql.node, convertFragment, props.draft);
  let formState = RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFacts_formState_graphql.node, convertFragment$1, props.formState);
  let match = PropertyWizardFormRelay.Context.use();
  let tmp;
  let tmp$1 = match.mode;
  tmp = typeof tmp$1 !== "object" ? JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__DraftType.make, {
      draft: draft.fragmentRefs
    }) : null;
  let match$1 = draft.draftProperty.propertyType;
  let tmp$2;
  tmp$2 = match$1 === "FOR_SALE" ? null : JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__RentalData.make, {
      draft: draft.fragmentRefs,
      stepHasBeenTouched: formState.stepKeyFactsTouched
    });
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      tmp,
      JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__StreetAddress.make, {
        draft: draft.fragmentRefs,
        formState: formState.fragmentRefs,
        stepHasBeenTouched: formState.stepKeyFactsTouched,
        duplicatedProperty: props.duplicatedProperty
      }),
      JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__Price.make, {
        draft: draft.fragmentRefs,
        stepHasBeenTouched: formState.stepKeyFactsTouched
      }),
      tmp$2,
      JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__PropertyType.make, {
        draft: draft.fragmentRefs,
        stepHasBeenTouched: formState.stepKeyFactsTouched
      })
    ]
  });
}

let DraftType;

let StreetAddress;

let Price;

let RentalData;

let PropertyType;

let make = PropertyWizardRelay__KeyFacts;

exports.DraftType = DraftType;
exports.StreetAddress = StreetAddress;
exports.Price = Price;
exports.RentalData = RentalData;
exports.PropertyType = PropertyType;
exports.DraftFragment = DraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
